import { Users } from "lucide-react";
import type { ModuleManifest } from "@/modules/module-registry";
import type { PermissionDefinition } from "@/modules/access";
import { colistiersDocumentKinds } from "./document-kinds";

// What the optional Colistiers module lets staff grant. `colistiers-app`: read: open the app. `colistiers`: read: see the elections and candidates; write: add, edit, reorder, record results and upload photos. Both are needed to open the app.
const colistiersPermissions: readonly PermissionDefinition[] = [
  { resource: "colistiers-app", label: "colistiers-app.resource", levels: ["read"], ownable: false, staffOnly: true },
  { resource: "colistiers", label: "colistiers.resource", levels: ["read", "write"], ownable: false, staffOnly: true },
];

/** The Colistiers module declares itself: an optional app, off until an administrator switches it on in the App store, and hidden completely when `COLISTIERS_HIDDEN` is "on" (see `hiddenModuleIds`). It needs no other module and adds nothing to them. */
export const colistiersManifest: ModuleManifest = {
  id: "colistiers", href: "/colistiers", icon: Users,
  name: "auth.modules.colistiers", description: "settings.appStore.apps.colistiers.description",
  permissionDefinitions: colistiersPermissions,
  permissions: ["colistiers-app", "colistiers"], appPermission: "colistiers-app", needs: [], contributes: [],
  optional: true, documentKinds: colistiersDocumentKinds,
};
